import React from 'react'

import LoadUserSchoolRoles from 'App/views/SchoolDataRoleSelection/LoadUserSchoolRoles'

import LoadRoles from './LoadRoles'
import SchoolDataRoleSelectionView from './SchoolDataRoleSelectionView'

const SchoolDataRoleSelection = () => (
  <LoadRoles>
    <LoadUserSchoolRoles>
      <SchoolDataRoleSelectionView />
    </LoadUserSchoolRoles>
  </LoadRoles>
)

export { SchoolDataRoleSelection }
